/**
 * @generated SignedSource<<6ed21bcd4cae31006b12c5196a23b5f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CartSubstitutions_product$data = {
  readonly fullName: string | null | undefined;
  readonly productId: string | null | undefined;
  readonly " $fragmentType": "CartSubstitutions_product";
};
export type CartSubstitutions_product$key = {
  readonly " $data"?: CartSubstitutions_product$data;
  readonly " $fragmentSpreads": FragmentRefs<"CartSubstitutions_product">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartSubstitutions_product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "fb8b596fc8d250ad44fef3a9137b7b62";

export default node;
